import { createRouter, createWebHistory } from 'vue-router'
import { registerModules } from '@/register-modules'

const routes = [
  {
    path: '/',
    name: 'AppShell',
    component: () => import('@/components/app/AppShell.vue'),
    children: [
      {
        path: '',
        redirect: '/rules',
      },
    ],
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

registerModules(router)

export default router
